import { useCallback, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { useLanguageOptions } from '@/components/LanguageSelector/hooks';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/form/Select';
import { setLanguage } from '@/store/profile/index';
import { updateUser } from '@/store/profile/thunks';
import { capitalize, showError, showSuccess } from '@/utils';

import SectionForm from '../SectionForm';

function Language({ title, description }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const langOptions = useLanguageOptions();
	const currentLanguage = useSelector(state => state.profile.language);

	const schema = Yup.object({
		language: Yup.string().required()
	});

	const methods = useForm({
		resolver: yupResolver(schema),
		mode: 'onChange',
		defaultValues: {
			language: currentLanguage || 'en'
		}
	});

	const onSubmit = useCallback(async function (values) {
		setLoading(true);
		dispatch(
			updateUser({
				language: values.language
			})
		)
			.unwrap()
			.then(() => {
				dispatch(setLanguage(values.language));
				setLoading(false);
				showSuccess(t('account.toast'));
			})
			.catch(error => {
				showError(error);
				setLoading(false);
			});
	}, []);

	return (
		<SectionForm
			title={title}
			description={description}
			methods={methods}
			onSubmit={onSubmit}
			loading={loading}
		>
			<div className="m-0 flex w-full flex-col items-center">
				<div className="flex w-full flex-col gap-x-5 gap-y-4 lg:gap-y-6">
					<Select
						name="language"
						label={`${t('account.form.language')}`}
						className="bg-white"
					>
						<SelectTrigger
							className="group border-gray-200 bg-white p-0 text-grey-500 group-hover:text-grey-500"
							aria-label={t('labels.language')}
						>
							<SelectValue />
						</SelectTrigger>
						<SelectContent className="max-h-56 bg-white text-grey-500 md:max-h-96">
							{langOptions.map(({ value, label }, index) => (
								<SelectItem
									className="text-grey-500 hover:bg-grey-100 data-[state=checked]:bg-grey-100 data-[state=checked]:text-black"
									key={index}
									value={value}
								>
									{capitalize(label)}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
			</div>
		</SectionForm>
	);
}

export default Language;
